<template>

  <div>

  <TemplateModal
    v-bind:modalId="modalId">
      
    <h4 slot="modal-title" class="modal-title" v-html="modalTitle || (modalIsAdd ? 'Add Data' : 'Edit Data')">
    </h4>

    <div slot="modal-body">
      <AppForm 
        ref="modalForm"
        v-show="modalFormVisible"
        v-bind:formParameter="formParameter"
        v-bind:permission="permission"
        v-on:form-input="onFormInput"
        v-on:form-change="onFormChange">

        <slot 
          v-for="parameter of formParameter"
          v-bind:name="'jt-form-slot-' + parameter.key"
          v-bind:slot="'jt-form-slot-' + parameter.key" />

      </AppForm>

      <slot/>

      <TemplateFeedback ref="modalFeedback" />
    </div>

    <div slot="modal-footer">
      <slot name="modal-footer-before"/>
      <button type="button" class="btn btn-default" data-dismiss="modal">
        Close
      </button>
      <button v-show="hasDeletePermission() && modalShowDelete && modalCanDelete && !modalIsAdd" @click="onModalPromptDeleteData" type="button" class="btn btn-danger">
        Delete
      </button>
      <button v-show="hasEditPermission() && modalShowEdit && modalCanEdit && !modalIsAdd" @click="onModalEditData" type="button" class="btn btn-success">
        Save
      </button>
      <TemplateButton v-show="hasAddPermission() && modalShowAdd && modalCanAdd && modalIsAdd" @click="onModalAddData" type="button" class="btn btn-success">
        Add
      </TemplateButton>
      <slot name="modal-footer-after"/>
    </div>

  </TemplateModal>

  <TemplateModal
    v-bind:modalId="modalId + '-delete'">

    <h4 slot="modal-title" class="modal-title" >
      {{ modalConfirmDeleteTitle || 'Confirm Delete' }}
    </h4>

    <div slot="modal-body">
      {{ modalConfirmDeleteBody || 'Are you sure you want to delete the selected item?' }}
    </div>

    <div slot="modal-footer">
      <button type="button" class="btn btn-default" data-dismiss="modal">
        Close
      </button>
      <button v-show="modalCanDelete && !modalIsAdd" @click="onModalDeleteData" type="button" class="btn btn-danger">
        Confirm
      </button>
    </div>

  </TemplateModal>

  <!--
  <div v-bind:id="modalId" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="popup-label">
    <div class="modal-dialog" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h4 class="modal-title" >
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div class="modal-body">

          <AppForm 
            ref="modalForm"
            v-bind:formParameter="formParameter" />

          <TemplateFeedback ref="modalFeedback" />
          
        </div>

        <div class="modal-footer">
          <slot name="modal-footer-before"/>
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
          <button v-show="modalCanDelete && !modalIsAdd" @click="onModalPromptDeleteData" type="button" class="btn btn-danger">
            Delete
          </button>
          <button v-show="modalCanEdit && !modalIsAdd" @click="onModalEditData" type="button" class="btn btn-success">
            Save
          </button>
          <button v-show="modalCanAdd && modalIsAdd" @click="onModalAddData" type="button" class="btn btn-success">
            Add
          </button>
          <slot name="modal-footer-after"/>
        </div>

      </div>
    </div><
  </div>
  -->

  <!--
  <div v-bind:id="modalId + '-delete'" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="popup-label">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          {{ modalConfirmDeleteBody || 'Are you sure you want to delete the selected item?' }}
        </div>
        <div class="modal-footer">
          <slot name="modal-footer-before"/>
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
          <button v-show="modalCanDelete && !modalIsAdd" @click="onModalDeleteData" type="button" class="btn btn-danger">
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
  -->

  </div>

</template>

<script>
import AppForm from "@/components/App/AppForm";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import TemplateModal from "@/components/Template/TemplateModal";
import TemplateButton from "@/components/Template/TemplateButton";
import helper from "@/components/Utility/Helper"

export default {
  name: "AppModalForm",
  props: {
    'permission': null,
    'formParameter': null,

    'modalShowDelete': {
      default: true
    },
    'modalShowEdit': {
      default: true
    },
    'modalShowAdd' : {
      default: true
    },
  },
  components: {
    AppForm,
    TemplateFeedback,
    TemplateModal,
    TemplateButton,
  },
  data () {
    return {
      modalId: null,

      modalIsAdd: true,
      modalTitle: null,

      modalConfirmDeleteTitle: null,
      modalConfirmDeleteBody: null,

      modalCanDelete: true,
      modalCanEdit: true,
      modalCanAdd: true,

      modalFormVisible: true,
    }
  },
  computed: {
    // will not update if formIsAdd changed
    modalFormIsAdd: function() {
      return this.$refs['modalForm'] ? this.$refs['modalForm'].formIsAdd : true;
    },
  },
  mounted() {
    this.modalId = "jt-popup-modal-" + this._uid;
  },
  methods: {
    setModalOpen(modalIsAdd, modalTitle, modalData) {
      this.modalIsAdd = modalIsAdd;
      this.modalTitle = modalTitle;

      let actualCanAddOrEdit;
      if(modalIsAdd) {
        actualCanAddOrEdit = this.hasAddPermission() && this.modalCanAdd;
      } else {
        actualCanAddOrEdit = this.hasEditPermission() && this.modalCanEdit;
      }

      this.$refs['modalForm'].setForm(modalIsAdd, modalData, actualCanAddOrEdit);
      
      this.$refs['modalFeedback'].setFeedbackMessage(null);
      // TODO kw find a correct way to open modal in vuejs
      // sample found online is using component but if component isn't at root 
      // the backdrop won't cover the whole page
      $('#' + this.modalId).modal('show');
    },
    setModalClose() {
      this.$refs['modalFeedback'].setFeedbackMessage(null);
      $('#' + this.modalId).modal('hide');
    },
    setModalLoading(message) {
      this.$refs['modalFeedback'].setFeedbackLoading(message);
    },
    setModalError(error) {
      this.$refs['modalFeedback'].setFeedbackError(error);
    },
    setModalMessage(message) {
      this.$refs['modalFeedback'].setFeedbackMessage(message);
    },

    onModalAddData() {
      if(!this.$refs['modalForm'].validateForm()) {
        this.$emit('modal-data-add', this.$refs['modalForm'].formData);
      }
    },
    onModalEditData() {
      if(!this.$refs['modalForm'].validateForm()) {
        this.$emit('modal-data-edit', this.$refs['modalForm'].formData);
      }
    },
    onModalPromptDeleteData() {
      let formData = this.$refs['modalForm'].formData;
      this.modalConfirmDeleteTitle = this.formatModalConfirmDeleteTitle(formData) || (formData.name ? `Confirm Delete ${formData.name}?` : null);
      this.modalConfirmDeleteBody = this.formatModalConfirmDeleteBody(formData) || (formData.name ? `Are you sure you want to delete ${formData.name}?` : null);
      $('#' + this.modalId + '-delete').modal('show');
    },
    onModalDeleteData() {
      this.$emit('modal-data-delete', this.$refs['modalForm'].formData);
      $('#' + this.modalId + '-delete').modal('hide');
    },

    formatModalConfirmDeleteTitle(formData) {
    },
    formatModalConfirmDeleteBody(formData) {
    },

    onFormInput(formData, formParameter, input) {
      this.$emit('modal-data-input', formData, formParameter, input);
    },
    onFormChange(formData, formParameter, input) {
      this.$emit('modal-data-change', formData, formParameter, input);
    },

    hasAddPermission() {
      return helper.hasAddPermission(this.permission);
    },
    hasEditPermission() {
      return helper.hasEditPermission(this.permission);
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/App/AppModalForm.vue